<div class="lk-wrap">
  <input type="text" class="form-control form-control-sm lk-input" autocomplete="off"
         role="combobox" [attr.aria-expanded]="open()"
         [attr.maxlength]="maxLength"
         [id]="inputId || null"
         [attr.tabindex]="tabindex"
         [placeholder]="placeholder"
         [disabled]="disabled()"
         [value]="displayText()"
         [appManglish]="manglish"
         [manglishDefault]="manglishDefault"
         (patternChange)="manglishPattern.set($event)"
         (modeChange)="manglishMode.set($event)"
         (input)="onInput($any($event.target).value)"
         (keydown)="onKeydown($event)"
         (focus)="onFocus()"
         (blur)="onBlur()">
  @if (manglish && manglishMode() === 'manglish') {
    <span class="lk-mode-badge" aria-hidden="true" title="Manglish (F6)">മ</span>
  }
  @if (pending()) {
    <span class="lk-spinner" aria-hidden="true"></span>
  }
  <!-- Panel shows for the options dropdown (open) OR, even when suggestions are
       off, just the Manglish alternates strip while a transliteration pattern is
       active and the field is focused (owner directive 2026-07-14). -->
  @if (panelVisible()) {
    <div class="lk-dropdown" role="listbox" (mousedown)="$event.preventDefault()"
         [class.lk-up]="openUp()">
      @if (manglishAlternates().length) {
        <div class="lk-alt-strip">
          @for (alt of manglishAlternates(); track alt.key) {
            <button type="button" class="lk-alt"
                    [class.lk-alt-active]="alt.key === manglishPattern()"
                    (click)="pickAlternate(alt.key)">{{ alt.glyph }}</button>
          }
          <span class="lk-alt-hint">Tab: മാറ്റുക / cycle</span>
        </div>
      }
      @if (open()) {
      @if (!filtered().length) {
        <div class="lk-empty">{{ pending() ? 'Searching…' : 'No matches' }}</div>
      } @else if (isVirtual()) {
        <cdk-virtual-scroll-viewport [itemSize]="itemSize" class="lk-viewport" [style.height.px]="viewportHeight()">
          <div *cdkVirtualFor="let option of filtered(); let i = index"
               class="lk-item" role="option"
               [class.lk-active]="highlighted() === i"
               [class.lk-selected]="multiple && isOptionSelected(option)"
               [attr.aria-selected]="multiple ? isOptionSelected(option) : null"
               [style.height.px]="itemSize"
               (click)="onOptionClick(option)">@if (multiple) {<input type="checkbox" class="lk-check" tabindex="-1"
                     [checked]="isOptionSelected(option)" (click)="$event.preventDefault()">}@if (option.imageUrl || option.icon) {<span class="lk-chip-box">@if (option.imageUrl) {<img [src]="option.imageUrl" class="lk-chip-img" alt="" (error)="$any($event.target).style.display='none'">} @else if (option.icon) {<i [class]="option.icon" aria-hidden="true"></i>}</span>}{{ label(option) }}@if (option.hint) {<span class="lk-hint">{{ option.hint }}</span>}</div>
        </cdk-virtual-scroll-viewport>
      } @else {
        <ul class="lk-list">
          @for (option of filtered(); track option.id; let i = $index) {
            @if (isGroupStart(i)) {
              <li class="lk-group-header" role="presentation">{{ option.group }}</li>
            }
            <li class="lk-item" role="option"
                [class.lk-active]="highlighted() === i"
                [class.lk-selected]="multiple && isOptionSelected(option)"
                [attr.aria-selected]="multiple ? isOptionSelected(option) : null"
                (click)="onOptionClick(option)">@if (multiple) {<input type="checkbox" class="lk-check" tabindex="-1"
                       [checked]="isOptionSelected(option)" (click)="$event.preventDefault()">}@if (option.imageUrl || option.icon) {<span class="lk-chip-box">@if (option.imageUrl) {<img [src]="option.imageUrl" class="lk-chip-img" alt="" (error)="$any($event.target).style.display='none'">} @else if (option.icon) {<i [class]="option.icon" aria-hidden="true"></i>}</span>}{{ label(option) }}@if (option.hint) {<span class="lk-hint">{{ option.hint }}</span>}</li>
          }
        </ul>
      }
      <!-- Pinned footer rows (AppLookupFooterItem) — always below the options
           list while the dropdown is open, never filtered by the typed term
           (the legacy .auto_suggest_footer rows). Click-only. -->
      @if (footerItems.length) {
        <div class="lk-footer" role="presentation">
          @for (item of footerItems; track item.id) {
            <div class="lk-footer-item" (click)="onFooterClick(item)">
              @if (item.icon) {
                <i class="fa fa-{{ item.icon }} lk-footer-icon" aria-hidden="true"></i>
              }
              <span class="lk-footer-label">{{ item.label }}</span>
            </div>
          }
        </div>
      }
      }
    </div>
  }
</div>
